import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import Button from '../../components/Button/Button';
import styles from './SendNotification.module.css';

const SendNotification = () => {
  const navigate = useNavigate();
  const [audience, setAudience] = useState('Participants');
  const [selectedFilters, setSelectedFilters] = useState(['Delhi NCR', 'Age 18–25', 'Verified only']);
  const [selectedChannels, setSelectedChannels] = useState(['Push', 'WhatsApp']);
  const [title, setTitle] = useState('New gaming studies in Delhi');
  const [message, setMessage] = useState('3 new studies this week, up to ₹5000. Apply before seats fill.');

  const toggleFilter = (f) => {
    if (selectedFilters.includes(f)) {
      setSelectedFilters(selectedFilters.filter((item) => item !== f));
    } else {
      setSelectedFilters([...selectedFilters, f]);
    }
  };

  const toggleChannel = (c) => {
    if (selectedChannels.includes(c)) {
      setSelectedChannels(selectedChannels.filter((item) => item !== c));
    } else {
      setSelectedChannels([...selectedChannels, c]);
    }
  };

  const headerActions = (
    <>
      <Button variant="secondary">Save draft</Button>
      <Button variant="secondary">Schedule</Button>
      <Button variant="primary" onClick={() => navigate('/notifications')}>
        Send now
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        backTo="/notifications"
        backText="← Notifications"
        title="New notification"
        subtitle="Send an announcement to participants or researchers."
        actions={headerActions}
      />

      <div className={styles.mainGrid}>
        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Message settings</h2>

          <div className={styles.fieldGroup}>
            <span>Audience</span>
            <div className={styles.pillGroup}>
              {['Participants', 'Researchers'].map((aud) => (
                <button
                  key={aud}
                  type="button"
                  onClick={() => setAudience(aud)}
                  className={`${styles.pillBtn} ${audience === aud ? styles.pillBtnActive : ''}`.trim()}
                >
                  {aud}
                </button>
              ))}
            </div>
          </div>

          <div className={styles.fieldGroup}>
            <span>Audience filters</span>
            <div className={styles.pillGroup}>
              {['Delhi NCR', 'Mumbai', 'Age 18–25', 'Verified only', 'Active in 30 days'].map((flt) => (
                <button
                  key={flt}
                  type="button"
                  onClick={() => toggleFilter(flt)}
                  className={`${styles.pillBtn} ${selectedFilters.includes(flt) ? styles.pillBtnActive : ''}`.trim()}
                >
                  {flt}
                </button>
              ))}
            </div>
          </div>

          <div className={styles.fieldGroup}>
            <span>Channel</span>
            <div className={styles.pillGroup}>
              {['Push', 'WhatsApp', 'SMS', 'Email'].map((ch) => (
                <button
                  key={ch}
                  type="button"
                  onClick={() => toggleChannel(ch)}
                  className={`${styles.pillBtn} ${selectedChannels.includes(ch) ? styles.pillBtnActive : ''}`.trim()}
                >
                  {ch}
                </button>
              ))}
            </div>
          </div>

          <label className={styles.labelField}>
            <span>Title</span>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className={styles.inputField}
            />
          </label>

          <label className={styles.labelField}>
            <span>Message</span>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className={styles.textareaField}
            />
          </label>
        </section>

        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Preview</h2>
          <div className={styles.previewPhoneCard}>
            <div className={styles.previewLogo}>N</div>
            <div className={styles.previewContent}>
              <span className={styles.previewTitle}>{title}</span>
              <span className={styles.previewBody}>{message}</span>
            </div>
          </div>
          <div className={styles.metaRow}>
            <span className={styles.metaLabel}>Estimated reach</span>
            <span className={styles.metaValue}>3,120 participants</span>
          </div>
          <div className={styles.metaRow}>
            <span className={styles.metaLabel}>WhatsApp cost</span>
            <span className={styles.metaValue}>₹0.48 / message</span>
          </div>
        </section>
      </div>
    </>
  );
};

export default SendNotification;
